import React from "react";
import * as R from "ramda";
import { Button, Dropdown, Icon, Menu, message, Tooltip } from "antd";

import {
  registerResource,
  registerVideoResourceByUrl,
} from "./useCustomRequest";
import {
  TreeNodeTextToValueMap,
  uploadResourceChannelMap,
} from "../tab-pages/video-resource-page";
import { addTag } from "../aliyun-service-api";
import { uploadMediaOssUrl } from "./upload-resource";
import { UploadResourceModalForm } from "./upload-resource-modal";

export const TooltipIcon = ({ title }) => {
  return (
    <Tooltip title={title}>
      <Icon className="cursor-pointer ml-2" type="info-circle" />
    </Tooltip>
  );
};
/**
 * @param props Object {
 *   options: Array<{
 *      key: string,
 *      label: string,
 *      tooltip?: string
 *   }>,
 *   onSelect: (key)=>void;
 *   children: any;
 * }
 * @constructor
 */
export const ButtonSelectToCreate = (props) => {
  const { options = [], onSelect = R.T, children = null } = props;
  return (
    <Dropdown
      overlay={
        <Menu onClick={({ key }) => onSelect(key)}>
          {options.map(({ key, label, tooltip }) => (
            <Menu.Item key={key}>
              {label}
              {tooltip && <TooltipIcon title={tooltip} />}
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <Button type="primary" icon="down">
        {children}
      </Button>
    </Dropdown>
  );
};

export const DropdownSelectUploadType = (props) => {
  const afterDone = R.pathOr(R.T, ["afterDone"], props);
  const orderId = R.pathOr("", ["match", "params", "orderid"], props);
  const userId = R.pathOr("", ["user", "id"], props);
  const selectedType = R.pathOr("", ["selectedType"], props);
  //  是否选中了片头片尾
  const isHeadTail = R.equals(TreeNodeTextToValueMap["片头片尾"], selectedType);
  return (
    <UploadResourceModalForm {...props}>
      {({ open, form }) => (
        <Dropdown
          overlay={
            <Menu
              onClick={({ key: keyType }) => {
                open({ type: keyType }).then((values) => {
                  const isVideo = R.equals("video", keyType);
                  const videoUrl = R.pathOr("", ["videoUrl"], values);

                  const isVideoAndHasUrl = isVideo && videoUrl;

                  const file = R.pathOr(
                    {},
                    ["file", "fileList", 0, "originFileObj"],
                    values
                  );

                  const fileIsEmpty = R.isEmpty(file);

                  const extraParams = {
                    channel: isHeadTail ? uploadResourceChannelMap.片头片尾 : uploadResourceChannelMap.本地手动上传,
                    ...R.omit(["file"], values),
                  };
                  const key = (file.url || "").replace(uploadMediaOssUrl, "/");
                  (isVideoAndHasUrl
                    ? registerVideoResourceByUrl(
                        videoUrl,
                        orderId,
                        userId,
                        extraParams
                      )
                    : registerResource(file, key, orderId, userId, extraParams)
                  ).then((res) => {
                    const id = R.pathOr("", ["id"], res);
                    !fileIsEmpty &&
                      message.success({
                        content: `${file.name} 上传成功`,
                        key,
                      });
                    //  reset form
                    form.resetFields();
                    afterDone(file);
                    const tag = R.pathOr("", ["tag"], values);
                    if (tag) {
                      addTag(orderId, id, tag);
                    }
                    if (props.onSuccess) {
                      props.onSuccess(values);
                    }
                  });
                }, console.warn);
              }}
            >
              <Menu.Item key="video">
                添加{isHeadTail ? "片头片尾" : ""}视频
              </Menu.Item>
              <Menu.Item key="image">
                添加{isHeadTail ? "片头片尾" : ""}图片
              </Menu.Item>
              {!isHeadTail && <Menu.Item key="audio">添加音频</Menu.Item>}
              {!isHeadTail && (
                <Menu.Item key="text">
                  添加字幕
                  <TooltipIcon title="阿里云不支持导入字幕, 仅提供上传下载功能" />
                </Menu.Item>
              )}
            </Menu>
          }
        >
          <Button type="primary" icon="down">
            {isHeadTail ? '添加片头片尾' : '添加素材'}
          </Button>
        </Dropdown>
      )}
    </UploadResourceModalForm>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/dropdown-select-upload-type.js